<div class="title" [innerHTML]="title"></div>
<ion-toggle
  [(ngModel)]="value"
  color="variant-secondary"
  (ionChange)="updateChanges()"
  (ionFocus)="markAsTouched()"
></ion-toggle>
